// src/RequireAuth.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated, logout } from "./utils/auth";

function RequireAuth({ children }) {
  const location = useLocation();

  // Si el token NO existe o está EXPIRADO, lo sacamos del sistema
  if (!isAuthenticated()) {
    logout(); // seguridad adicional
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Si el token está OK → permitir acceso
  return children;
}

export default RequireAuth;
